import React from "react";
import { useBranding } from "../utils/branding";

// Ownezzy's logo: `wide` (logo and name, for headers) or the round one
export default function OwnezzyLogo({ wide = false, className = "" }) {
  const logos = useBranding();
  return <img className={`ownezzy-logo ${wide ? "ownezzy-logo-wide" : "ownezzy-logo-round"} ${className}`} src={wide ? logos.logoWide : logos.logo} alt="Ownezzy" />;
}
